import { useState } from 'react';
import type { GoogleGenAI } from "@google/genai";

export const useGeminiAI = () => {
  const [ai] = useState<GoogleGenAI | null>(null);
  const [aiInitializationError] = useState<string | null>(null);

  return { ai, aiInitializationError };
};

